import { useState } from "react";

const COPY_TEXT =
  "「吃瓜91」网络数字梗：吃瓜=围观八卦、坐等更新，91 谐音“就要/就一”，整体像一句“前排就位、等瓜开”的进场暗号。偏闲聊轻松场合，无唯一官方定义（民间说法整理）。";

export default function CopyCard() {
  const [copied, setCopied] = useState(false);

  const doCopy = async () => {
    try {
      await navigator.clipboard.writeText(COPY_TEXT);
    } catch {
      const ta = document.createElement("textarea");
      ta.value = COPY_TEXT;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      document.execCommand("copy");
      document.body.removeChild(ta);
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 2200);
  };

  return (
    <section id="copy" className="scroll-mt-24 border-t border-primary-200 bg-accent-50 py-14 md:py-20">
      <div className="wrap">
        <div className="grid items-center gap-8 rounded-lg bg-background-50 p-6 md:p-10 lg:grid-cols-[1.4fr_1fr]">
          <div>
            <span className="inline-flex items-center gap-2 rounded-full bg-accent-100 px-3 py-1 text-xs font-semibold text-accent-700">
              <i className="ri-download-2-line h-4 w-4 flex items-center justify-center" />
              随手带走
            </span>
            <h2 className="eyebrow mt-4 text-2xl font-black text-foreground-950 md:text-3xl">
              一句话释义，复制就能用
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
              别人再甩「吃瓜91」给你，直接把这段话发出去，既解释了意思，又显得你懂行。不用登账号、不用装东西，点一下就好。
            </p>

            <div className="mt-6 rounded-lg border border-background-200 bg-background-100 p-4 font-poster text-[15px] leading-loose text-foreground-900">
              {COPY_TEXT}
            </div>
          </div>

          <div className="flex flex-col items-stretch gap-3 lg:items-start">
            <button
              type="button"
              onClick={doCopy}
              className="inline-flex w-full items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 lg:w-auto"
            >
              <i
                className={`h-4 w-4 flex items-center justify-center ${copied ? "ri-check-line" : "ri-clipboard-line"}`}
              />
              {copied ? "已复制，拿去用" : "复制这段释义"}
            </button>

            <div className="flex w-full flex-col gap-2 text-xs text-foreground-500 lg:w-64">
              <div className="flex items-center gap-2">
                <i className="ri-shield-check-line h-4 w-4 flex items-center justify-center text-accent-600" />
                纯文字，无账号、无登录
              </div>
              <div className="flex items-center gap-2">
                <i className="ri-bubble-chart-line h-4 w-4 flex items-center justify-center text-secondary-600" />
                可直接粘贴到聊天里
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}